import { Field, Switch, Icon, Popup, Button, Tab, Tabs, Space } from "vant";
import ConfirmPurchase from "@/components/confirm-purchase";
import MetfoneNotify from "@/components/metfone-notify"; 
import DataNotify from "@/components/data-notify";
import PostMetfoneService from "@/components/post-metfone-service.vue";
import packageOfData from "@/mocks/packageOfData";
import { ref } from "vue";
import { mapState } from "vuex";
import store from "@/store";
import { CONSTANTS } from "@/helpers/constants";
import MetfoneLoading from "@/components/metfone-loading.vue";
import getErrorMessage from "@/helpers/error-server";
import { template } from "lodash";

import Devices from "@/components/devices.vue";
import { Search } from "vant/lib";
import axios from "axios";
import { preloadFaceLandmarker } from "@/ultis/faceLandmarkerService.js";
import { getPreviousRoute } from "@/router";
import MyOrder from "@/pages/EOrder/index.vue";
import TV360Home from "@/pages/TV360/home/index.vue";

import { version } from "@/../package.json";

export default {
  name: "Home",
  components: {
    MetfoneLoading,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Space.name]: Space,
    [Search.name]: Search,
    ConfirmPurchase,
    MetfoneNotify, 
    DataNotify,
    PostMetfoneService,
    Devices,
    MyOrder,
    TV360Home,
  },
  inject: ["$bridge"],
  setup() {
    const activeName = ref("mobileServicesa");
    return { activeName };
  },
  data() {
    return {
      item: null,
      data: packageOfData,
      switchChecked: false,
      showDetail: false,
      activeName: false,
      metfoneServices: null,
      detailPackage: null,
      loadingService: false,
      itemActive: null,
      buyMetfoneeSim: null,
      isShowDevices: false,
      devices: null,
      itemFaceLandmarker: null,
      isShowMyOrder: "buyEsim",
      packageHistory: [],
      packageHistoryPage: 1,
      packageHistoryPageSize: 10,
      packageHistoryLoading: false,
      packageHistoryFinished: false,
      showCenter: false,
      imageUrl: "img/header-modal-detail-package.png",
      detailModel: {
        name: null,
        fullDes: null,
        type: null,
      },
      showChangeToEsimPopup: false,
      versionCode: version,
    };
  },
  async created() {
    if (!this.loadingFinished) {
      this.$router.replace("/"); // Chuyển về trang loading
      return;
    }

    this.$store.dispatch("routerStore/setIsBackToHomeFromOrder", true);

    await this.getListPackage();
    if (this.activeName === "mobileServices" && this.isShowContentMobileServices === "history") {
      this.getPackageHistory();
    }
    this.checkPlatform();
    await this.getListSupportDevice();
    // await this.initFaceLandmarker();
    console.log("version", version);
    this.versionCode = version;
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("facemarkerStore", ["faceLandmarker"]),
    ...mapState("loadingStore", ["loadingFinished"]),
    ...mapState("routerStore", ["isShowContentBuyMetfoneEsim", "isShowContentMobileServices"]),
    ...mapState("headerStore", ["title"]),
    getfullName() {
      if (this.profile) {
        let fullName = "";
        if (this.profile.firstName) {
          fullName = `${this.profile.firstName} `;
        }
        if (this.profile.middleName) {
          fullName += `${this.profile.firstName} `;
        }
        if (this.profile.lastName) {
          fullName += `${this.profile.lastName}`;
        }
        return fullName;
      }

      return "";
    },
  },
  mounted() {
    // if (this.$route.name == "Home") {
    //   window.onpopstate = null;
    // }
    // if (event.state.forward == "/") {
    //   window.$bridge.callHandler("closeApp");
    // }

    this.changeTitle(this.$t(this.title));

    this.$store.dispatch("routerStore/setIsBackToHomeFromOrder", true);
    window.addEventListener("afterHomeRoute", this.handleAfterRoute);
    preloadFaceLandmarker()
      .then(() => {
        console.log("✅ FaceLandmarker đã preload!");
      })
      .catch((err) => {
        console.error("❌ Lỗi preload FaceLandmarker:", err);
      });
  },
  watch: {
    "$route.hash": {
      handler: function (dialog_id) {
        if (dialog_id !== "#postservice") {
          this.showDetail = false;
          this.itemActive = null;
          store.dispatch("routerStore/setActionModalClose", null);
        }
      },
      immediate: true,
    },
    "$route.query": {
      handler: function (query) {
        if (query.tab) {
          this.activeName = query.tab;
        } else {
          this.activeName = "mobileServices";
        }
      },
      immediate: true,
    },
    showDetail(value) {
      if (value == false) {
        // this.item = null;
      }
    },
    defaultParam(value) {
      if (value) this.getListPackage();
    },
    activeName(newValue) {
      store.dispatch("routerStore/setIsShowActiveTabs", newValue);
    },

    isShowContentBuyMetfoneEsim: {
      handler(value) {
        //console.log("isShowContentBuyMetfoneEsim changed to true", value);
        this.isShowMyOrder = value;
      },
      immediate: true,
    },
    isShowContentMobileServices: {
      handler(value) {
        if (this.activeName === "mobileServices" && value === "history") {
          this.packageHistoryPage = 1;
          this.packageHistoryFinished = false;
          this.packageHistory = [];
          this.getPackageHistory();
        }
      },
      immediate: true,
    },
    $route: {
      handler: function (value) {
        this.$store.dispatch("headerStore/setTitle", "metfone_services");
      },
      immediate: true,
    },
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },
    handleGoToHistory(url) {
      if (url != +"/" + this.routerName()) this.$router.push(url);
    },
    routerName() {
      return this.$route.name;
    },
    changeTitle(title) {
      const contentData = {
        title: title,
        color: "#ffffff",
        bgColor: this.color_primary(),
      };
      //if (process.env.VUE_APP_BYPASS_NATIVE_API === "false") {
        this.$bridge.callHandler("setBarTitle", contentData).then((data) => {});
      //}
    },
    checkPlatform() {
      const isAndroidWebView =
        navigator.userAgent.toLowerCase().indexOf("android") > -1;

      // Check if the user agent contains "iPhone" or "iPad" to determine if it's an iOS WebView
      const isiOSWebView = /(iPhone|iPod|iPad)/i.test(navigator.userAgent);

      if (isAndroidWebView) {
        let parentElement = document.getElementById("parentElement");
        if (parentElement) {
          let childElements =
            parentElement.getElementsByClassName("van-tabs__wrap");
          if (childElements.length > 0) {
            const element = childElements[0];
            // element.style.top = '96px';

            const myDiv = document.getElementById("icon-history");
            const divHeight = myDiv.offsetHeight;
            element.style.top = divHeight + "px";
          }
        }

        // let iconHistory = document.getElementById("icon-history");
        // if(iconHistory){
        //     iconHistory.style.top = "64px";
        // }
        return 1;
      } else if (isiOSWebView) {
        let parentElement = document.getElementById("parentElement");
        if (parentElement) {
          let childElements =
            parentElement.getElementsByClassName("van-tabs__wrap");
          if (childElements.length > 0) {
            const element = childElements[0];
            const myDiv = document.getElementById("icon-history");
            const divHeight = myDiv.offsetHeight;
            element.style.top = divHeight + "px";
            // element.style.top = '60px';
          }
        }
        return 2;
      } else {
        let parentElement = document.getElementById("parentElement");
        if (parentElement) {
          let childElements =
            parentElement.getElementsByClassName("van-tabs__wrap");
          if (childElements.length > 0) {
            const element = childElements[0];
            // element.style.top = '96px';
            const myDiv = document.getElementById("icon-history");
            const divHeight = myDiv.offsetHeight;
            element.style.top = divHeight + "px";
            // element.style.top = '60px';
          }
        }
        // let iconHistory = document.getElementById("icon-history");
        // if(iconHistory){
        //     iconHistory.style.top = "64px";
        // }
        return 0;
      }
    },
    checkArray(array) {
      if (Array.isArray(array)) {
        return true;
      } else return false;
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    async handleShowDetail(item, value) {
      // this.showCenter = item;
      await this.getDetailPackage(value.serviceCode);
      if (this.item) {
        this.$store.dispatch("routerStore/setActionModalClose", true);
        this.showDetail = item;
        this.$router.replace("#postservice");
      }
    },
    handleShowPackageHistoryDetail(isShow, value) {
      if (isShow) {
        if (!value) return;
        this.detailModel.name = value.subServiceName || value.serviceName || "";
        this.detailModel.fullDes = value.fullDes || value.shortDes || "";
        this.detailModel.type = "history";
      } else {
        this.detailModel = {
          name: null,
          fullDes: null,
          type: null,
        };
      }
      this.showCenter = isShow;
    },
    async getListPackage() {
      if (this.defaultParam) {
        const defaultParam = this.stateAsObject(this.defaultParam);
        defaultParam.groupCode = "";
        let params = defaultParam;
        if (this.profile) {
          let tempPhone = this.profile.phone.replace(/\D/g, "");
          params.msisdn = tempPhone;
        }
        this.loadingService = true;
        await this.$store
          .dispatch("metfoneStore/getListPackage", params)
          .then((res) => {
            if (res) {
              let result = res.data;
              if (result && result.errorCode == 0) {
                const groupService = result.groupServices;
                if (Array.isArray(groupService)) {
                  this.metfoneServices = groupService[0].services;
                } else {
                  this.metfoneServices = groupService.services;
                }
              } else {
                this.$store.dispatch("notifyStore/addNotify", {
                  code: 1,
                  message: getErrorMessage(result.errorCode),
                });
              }
            }
          });

        this.loadingService = false;
      }
    },
    async getDetailPackage(serviceCode) {
      this.item = null;
      const defaultParam = this.stateAsObject(this.defaultParam);
      defaultParam.serviceCode = serviceCode;
      let params = defaultParam;
      this.$store.dispatch("loadingStore/showLoading", { status: true });
      await this.$store
        .dispatch("metfoneStore/getDetailPackage", params)
        .then((res) => {
          if (res) {
            let result = res.data;
            if (result && result.errorCode == 0) {
              this.item = result.service;
              this.itemActive = this.item.serviceCode;
              if (result.subServices && result.subServices.length > 0) {
                this.item.subFullDes = result.subServices[0].subFullDes;
                this.item.subCode = result.subServices[0].subCode;
              }
            } else {
              this.$store.dispatch("notifyStore/addNotify", {
                code: 1,
                message: getErrorMessage(result.errorCode),
              });
            }
          }
        });
      this.$store.dispatch("loadingStore/showLoading", { status: false });
    },

    async getPackageHistory() {
      if (!this.defaultParam) return;
      this.packageHistoryLoading = true;
      const defaultParam = this.stateAsObject(this.defaultParam);
      defaultParam.pageSize = this.packageHistoryPageSize;
      defaultParam.pageNumber = this.packageHistoryPage;
      let params = defaultParam;
      if (this.profile) {
        let tempPhone = this.profile.phone.replace(/\D/g, "");
        params.msisdn = tempPhone;
        params.partnerAccount = this.profile.id;
      }
      await this.$store
        .dispatch("metfoneStore/getListHistory", params)
        .then((res) => {
          if (res) {
            let result = res.data;
            if (result && result.errorCode == 0) {
              const histories = result.histories || [];
              if (this.packageHistoryPage === 1) {
                this.packageHistory = histories;
              } else {
                this.packageHistory.push(...histories);
              }
              if (histories.length < this.packageHistoryPageSize) {
                this.packageHistoryFinished = true;
              } else {
                this.packageHistoryPage += 1;
              }
            }
          }
        });
      this.packageHistoryLoading = false;
    },
    isObjectEmpty(obj) {
      return Object.entries(obj).length === 0;
    },

    /*======================================================*/
    /*================= BUY METFONE ESIM  ==================*/
    /*======================================================*/

    async handleTabChange(name) {
      if (name) {
        this.activeName = name;
        store.dispatch("routerStore/setIsShowActiveTabs", name);
        if (this.activeName === "mobileServices") {
          /*======================================================*/
          //Begin NewTV360
          const currentQuery = this.$route.query.tab;
          if (currentQuery) {
            this.$router.replace({
              path: "/home",
            });
          }
          //End NewTV360
          /*======================================================*/
          this.loadingService = false;
        }

        if (this.activeName === "buyMetfoneEsim") {
          const currentQuery = this.$route.query.tab;
          if (currentQuery !== "buyMetfoneEsim") {
            this.$router.replace({
              path: "/home",
              query: { tab: "buyMetfoneEsim" },
            });
          }

          this.getListSupportDevice();
        }

        /*======================================================*/
        //Begin NewTV360
        if (this.activeName === "tabTV360") {
          store.dispatch("headerStore/setTitle", "tv360.title");
          const currentQuery = this.$route.query.tab;
          if (currentQuery !== "tabTV360") {
            this.$router.replace({
              path: "/home",
              query: { tab: "tabTV360" },
            });
          }
        }
        //End NewTV360
        /*======================================================*/
      }
    },

    handleOpenBuyNewEsim() {
      this.$router.push({ name: "BuyNewMetfoneEsim" });
    },
    handleOpenChangeToEsim() {
      //this.$router.push({ name: "ChangeToEsimMetfone" });
      window.__ignoreActionClose = true;
      this.showChangeToEsimPopup = true;
    },
    onChangeToEsimPopupClosed() {
      window.__ignoreActionClose = false;
    },

    async getListSupportDevice() {
      this.devices = null;
      if (this.defaultParam) {
        const defaultParam = this.stateAsObject(this.defaultParam);
        let params = defaultParam;

        this.$store
          .dispatch("esimMetfoneStore/getListSupportDevice", params)
          .then((res) => {
            if (res) {
              let result = res.data;
              if (result && result.errorCode == 0) {
                if (
                  result.supportedDevices &&
                  result.supportedDevices.length > 0
                ) {
                  this.devices = result.supportedDevices;
                  if (result.isDisPlay == 0) {
                    this.isShowDevices = false;
                  } else {
                    this.isShowDevices = true;
                  }
                }
              } else {
                this.$notify({
                  code: result.errorCode,
                  message: result.message,
                });
              }
            }
          });
      }
    },

    handleAfterRoute(event) {
      const router = event.detail;
      const prevRoute = getPreviousRoute();
      if (
        router.query &&
        router.query.tab == "buyMetfoneEsim" &&
        prevRoute &&
        (prevRoute.fullPath == "/my-order" ||
          prevRoute.fullPath == "/esim-payment" ||
          prevRoute.fullPath == "/id-card" ||
          prevRoute.fullPath == "/esim/payment-success" ||
          prevRoute.fullPath == "/register-infor" ||
          prevRoute.fullPath == "/buy-new-metfone-esim" ||
          prevRoute.fullPath == "/change-to-esim-metfone")
      ) {
        if (this.activeName !== "buyMetfoneEsim") {
          this.activeName = "buyMetfoneEsim";
        }
        store.dispatch("routerStore/setActionModalClose", false);
      } else {
        store.dispatch("routerStore/setActionModalClose", null);
      }
    },
  },
};
